import { ServerSidePaginationInterface } from "../leads-table";

export class ServerSidePaginationModel implements ServerSidePaginationInterface {
  totalRecords: number;
  page: number
  pageSize: number;
  from: number;
  to: number;

  constructor(
    totalRecords = 0,
    page = 1,
    pageSize = 20,
    from = 0,
    to = 0,
  ) {
    this.totalRecords = totalRecords;
    this.page = page;
    this.pageSize = pageSize;
    this.from = from;
    this.to = to;
  }

  set(
    totalRecords = 0,
    page = 1,
    pageSize = 20,
    from = 0,
    to = 0,
  ): void {
    this.totalRecords = totalRecords;
    this.page = page;
    this.pageSize = pageSize;
    this.from = from;
    this.to = to;
  }
}